import { useNavigate } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";
import StyledLoadingButton from "../../../../common/providers/theme/design-tokens/LoadingButton/StyledLoadingButton";
import BreadcrumbNavigation from "../../../../common/components/tabs/BreadcrumbNavigation";
import PaperWrapperCentered from "../../../../common/components/item/PaperWrapperCentered";
import LocationForm from "./components/LocationForm";
import { RouteEnum } from "../../../../common/models/enums";

import { useLocationFormHandler } from "../../../../common/hooks/useLocationFormHandler";

const CreateLocationPage = () => {
  const navigate = useNavigate();
  const locationPath = location.pathname.includes("sensory")
    ? RouteEnum.SensorySystemSettings
    : RouteEnum.CustomerSettings;

  const onSubmitCancelHandler = () => {
    navigate(locationPath);
  };

  const { control, handleSubmit, errors, loading } = useLocationFormHandler(
    onSubmitCancelHandler
  );

  const breadcrumbItems = [
    { label: "Customer settings", path: locationPath },
    {
      label: "Add new location",
    },
  ];

  return (
    <>
      <Box sx={{ marginBottom: "1em" }}>
        <BreadcrumbNavigation items={breadcrumbItems} />
      </Box>

      <Typography variant="h3" sx={{ paddingBottom: "1em" }}>
        Add new location
      </Typography>

      <form onSubmit={handleSubmit}>
        <PaperWrapperCentered>
          <LocationForm control={control} errors={errors} />
        </PaperWrapperCentered>

        <Stack direction="row-reverse" spacing={2} sx={{ paddingTop: 3 }}>
          <StyledLoadingButton
            sx={{ marginTop: "1.5em" }}
            loading={loading}
            variant="contained"
            type="submit"
            color="primary"
          >
            Add new location
          </StyledLoadingButton>
          <StyledLoadingButton
            sx={{ marginTop: "1.5em" }}
            loading={loading}
            variant="outlined"
            color="inherit"
            onClick={onSubmitCancelHandler}
          >
            Cancel
          </StyledLoadingButton>
        </Stack>
      </form>
    </>
  );
};

export default CreateLocationPage;
